<template>
	<div class="home">
		<van-nav-bar
		  	:title="$t('NewDish.title')"
			left-arrow
		  	@click-left="$router.push('/SetMenu')">
			<van-icon name="./static/img/ok.png" slot="right" @click="createDish()" style="font-size: 24px;"/>
		</van-nav-bar>
		<van-cell-group>
			<van-field
			    v-model="dish.name"
			    :label="$t('NewDish.cookName')"
			    label-width="120"
			    clearable
			    :placeholder="$t('NewDish.inputName')"
				/>
			<van-field
			    v-model="dish.name_en"
			    :label="$t('NewDish.enName')"
			    label-width="120"
			    clearable
			    :placeholder="$t('NewDish.inputName')"
				/>
			<van-cell :title="$t('NewDish.pic')" title-style="width: 120px;flex:none;">
				<van-uploader :after-read="afterRead" >
					<van-image
						v-if="dish.img"
					  	width="55"
					  	fit="contain"
					  	height="55"
					  	:src="dish.img"
					/>
					<van-image
						v-else
					  	width="55"
					  	height="55"
					  	src="./static/img/add_img.png"
					/>
				</van-uploader>
			</van-cell>
			<van-panel :title="$t('NewDish.price')">
				<van-checkbox-group v-model="priceResult">
		  			<van-cell-group>
				  		<van-field
		  				v-model="dish.original_price"
		  				:label="$t('NewDish.oldPrice')"
		  				clearable
		  				:placeholder="$t('NewDish.inputOldPrice')">
				  			<van-checkbox
		  						@click="togglePrice('o')"
						        :name="'o'"
						        ref="price_checkboxes"
						        slot="left-icon">
							  	<img
							  		style="width: 20px;height: 20px"
							    	slot="icon"
							    	slot-scope="props"
							    	:src="props.checked?'./static/img/sele.png':'./static/img/unsele.png'"
							  	>
						    </van-checkbox>
						</van-field>
						<van-field
		  				v-model="dish.special_price"
		  				:label="$t('NewDish.newPrice')"
		  				clearable
		  				:placeholder="$t('NewDish.inputNewPrice')">
				  			<van-checkbox
		  						@click="togglePrice('s')"
						        :name="'s'"
						        ref="price_checkboxes"
						        slot="left-icon">
							  	<img
							  		style="width: 20px;height: 20px"
							    	slot="icon"
							    	slot-scope="props"
							    	:src="props.checked?'./static/img/sele.png':'./static/img/unsele.png'"
							  	>
						    </van-checkbox>
						</van-field>
				  	</van-cell-group>
			  	</van-checkbox-group>
			</van-panel>
			<van-cell :title="$t('NewDish.commend')" title-style="width: 120px;flex:none;">
				<van-rate
					style="height: 23px;"
				  	v-model="dish.level"
				  	:size="20"
				  	gutter="10px"
					icon="./static/img/Recommend-s.png"
				  	void-icon="./static/img/Recommend.png"
				/>
			</van-cell>
			<van-cell :title="$t('NewDish.setPrefer')" is-link @click="isPerferShow=true"></van-cell>
			<van-cell :title="$t('NewDish.category')" is-link @click="isTagShow=true"></van-cell>
		</van-cell-group>
		<van-popup
		  	v-model="isPerferShow"
		  	position="bottom"
		  	:style="{ height: '70%' }">
		  	<van-cell-group>
				<van-cell title="">
					<van-icon
					    slot="icon"
					    name="./static/img/dele_staff.png"
					    size="25px"
					    @click="isPerferShow=false"
				  	/>
					<van-icon
					    slot="right-icon"
					    name="./static/img/ok1.png"
					    size="25px"
					    @click="isPerferShow=false"
				  	/>
				</van-cell>
			</van-cell-group>
			<van-checkbox-group v-model="perferResult">
			  	<van-cell-group>
		    		<van-cell
		      		v-for="(perfer, index) in perfers"
		      		clickable
		      		:key="index"
		      		:title="perfer.name"
		      		@click="toggle(index)">
				      	<van-checkbox
					        :name="perfer.id"
					        ref="checkboxes"
					        slot="right-icon">
						  	<img
						  		style="width: 20px;height: 20px"
						    	slot="icon"
						    	slot-scope="props"
						    	:src="props.checked?'./static/img/sele.png':'./static/img/unsele.png'"
						  	>
					    </van-checkbox>
			    	</van-cell>
			  	</van-cell-group>
			</van-checkbox-group>
	  	</van-popup>
	  	<van-popup
		  	v-model="isTagShow"
		  	position="bottom"
		  	:style="{ height: '70%' }">
		  	<van-cell-group>
				<van-cell title="">
					<van-icon
					    slot="icon"
					    name="./static/img/dele_staff.png"
					    size="25px"
					    @click="isTagShow=false"
				  	/>
					<van-icon
					    slot="right-icon"
					    name="./static/img/ok1.png"
					    size="25px"
					    @click="isTagShow=false"
				  	/>
				</van-cell>
				<van-checkbox-group v-model="tagResult">
				  	<van-cell-group>
			    		<van-cell
			      		v-for="(tag, index) in tags"
			      		clickable
			      		:key="index"
			      		:title="tag.name"
			      		@click="togglePerfer(index)">
					      	<van-checkbox
						        :name="tag.id"
						        ref="perferboxes"
						        slot="right-icon">
							  	<img
							  		style="width: 20px;height: 20px"
							    	slot="icon"
							    	slot-scope="props"
							    	:src="props.checked?'./static/img/sele.png':'./static/img/unsele.png'"
							  	>
						    </van-checkbox>
				    	</van-cell>
				  </van-cell-group>
				</van-checkbox-group>
			</van-cell-group>
	  	</van-popup>
	</div>
</template>

<script>
export default {
    data () {
      	return {
      		dish:{
      			name:'',
      			name_en:'',
      			image_id:'',
      			img:'',
      			level:0,
      			store_id:sessionStorage.actShopId,
      			original_price:'',
      			special_price:'',
      			ids:'',
      			type:'o',
      			category:'m',
      		},
      		priceResult:['o'],
      		perfers:[],
      		tags:[],
      		isPerferShow:false,
			isTagShow:false,
			perferResult:[],
			tagResult:[],
      	}
    },
    mounted:function(){
    	this.getPerfers();
		this.getTags();
		
    },
    methods:{
		afterRead(file) {
      		// 此时可以自行将文件上传至服务器
      		console.log(file);
      		let formData=new FormData();
            formData.append('type','shop');
            formData.append('file',file.file);
      		this.$axios({
                method: 'post',
                url: this.$build+'/api/image',
                headers: {
                	'Content-Type':'multipart/form-data',
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                data:formData,
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
            		this.dish.image_id=res.data.success.image_id;
            		this.dish.img=res.data.success.url;
              //   	this.$toast({
	            	// 	type:'success',
	            	// 	message:res.data.message,
	            	// });           	
            	}else{
            		this.$toast.allowMultiple();
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
                this.$toast({
            		type:'fail',
            		message:this.$t('NewDish.message'),
        		});
            });
    	},
    	getPerfers(){
			// 获取
			this.$axios({
                method: 'get',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/tags/'+sessionStorage.actShopId+'/index/0/perfer',
            }).then(res => {
            	// console.log(res);
            	if(res.data.status==200){
                	this.perfers=res.data.data;
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('NewDish.message'),
        		});
            });
		},
		getTags(){
			// 获取
			this.$axios({
                method: 'get',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/tags/'+sessionStorage.actShopId+'/index/0/class',
            }).then(res => {
            	// console.log(res);
            	if(res.data.status==200){
                	this.tags=res.data.data;
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('NewDish.message'),
        		});
            });
		},
    	createDish(){
    		this.dish.ids=JSON.stringify(this.perferResult.concat(this.tagResult));
			if(this.dish.name&&this.dish.image_id&&this.dish.original_price&&this.dish.special_price&&this.dish.ids){
				this.$axios({
	                method: 'post',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/menu/store',
	                data:this.dish,
	            }).then(res => {
	            	console.log(res);
	            	if(res.data.status==200){
	                	this.$toast({
		            		type:'success',
		            		message:res.data.message,
		            	});
		            	const vm=this;
		            	setTimeout(function(){
	            			vm.$router.go(-1);
		            	},1500);     
	            	}else{
	            		this.$toast.allowMultiple();
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	this.$toast({
	            		type:'fail',
	            		message:this.$t('NewDish.message'),
            		});
	            });
			}else{
				this.$toast(this.$t('NewDish.toast'));
			}
    	},
    	toggle(index) {
  			this.$refs.checkboxes[index].toggle();
				
	    },
	    togglePerfer(index) {
  			this.$refs.perferboxes[index].toggle();
  			console.log(index)
  			console.log(this.$refs.perferboxes[index])
	    },
	    togglePrice(val){
	    	this.priceResult=[];
	    	this.priceResult.push(val);
	    	this.dish.type=this.priceResult[0];
	    },
    }
}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-field__left-icon .van-icon{
		font-size: 20px;
	}
	/deep/ .van-cell .van-icon{
		font-size: 20px;
	}
	.home{
		width: 100%;
		height: 100vh;
	}
	.bn{
		border: none;
	}
	.van-cell__value{
		text-align: left;
	}
</style>


// WEBPACK FOOTER //
// src/Shop/NewDish.vue